import { createAction, props } from '@ngrx/store';
import { ISignupRequest, ISignupResponse } from '../models/signup.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

//#region  Signup  user
export const loadSignupRequest = createAction('[Signup] Load Sign up Request', props<{ request: ISignupRequest }>());

export const loadSignupSuccess = createAction('[Signup] Load Sign up Success', props<{ response: ISignupResponse }>());

export const loadSignupFailure = createAction('[Signup] Load Sign up Failure', props<{ error: IGenericError<ErrorResponse> }>());

//#endregion
